// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { initialState, RequestState } from './state';
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';


/**
 * This effect is for listen Request actions, execute auth service call and dispatch in Request reducer.
 * For Request api call purpose.
 *
 * @author Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 17/06/2020 (Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>)  created Request reducer
 */
export function reducer(state = initialState, action: Actions | AuthActions): RequestState {
  switch (action.type) {
    // Request COMMON METHOD
    case ActionTypes.REQUEST_COMMON: {
      return state;
    }
    // Request Success COMMON METHOD
    case ActionTypes.REQUEST_COMMON_SUCCESS: {
      // commonly store and handle all Request modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }

    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      return initialState;
    }

    // CLEAR_BUSINESS_REDUCER METHOD ON BUSINESS CHANGE
    case AuthActionTypes.CLEAR_BUSINESS_REDUCER: {
      return initialState;
    }

    // DEFAULT
    default:
      return state;
  }
}
